import { HelpersService } from '../../../../../services/helpers.service';
import { inject, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobcardService } from '../../../../../services/jobcard.service';
import { PaymentService } from '../../../../../services/payment.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-jobcard-approval',
  templateUrl: './jobcard-approval.component.html',
  styleUrls: ['./jobcard-approval.component.scss'],
})
export class JobcardApprovalComponent implements OnInit {
  public helpersService = inject(HelpersService);


  @Input() jobCardID: any

  public serviceid: string;
  public lineItems: any;
  public currencySymbol: string;
  public discount = 0;
  public excluding = 0;
  public tax = 0;
  public total = 0;
  public vatInclusive = true;
  public approvedList: boolean[] = [];
  public allApproved = true;
  public sent = false;
  public sentApproval: boolean;
  public jobCard: any = {};
  public canDoKlarnaPayment = false;
  public technicianName: string = '';
  public technicianPhoto: string = '';

  public showLabourHeading: boolean = false;
  public showProductsHeading: boolean = false;
  public labourAmount = 0;
  public partsAmount = 0;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public jobcardService: JobcardService,
    public paymentService: PaymentService,
  ) {}

  ngOnInit() {
    this.serviceid = this.route.snapshot.paramMap.get('serviceid');

    var partnerID = this.route.snapshot.queryParamMap.get('Theme');

    if (this.jobCardID && !this.serviceid)
      this.serviceid = this.jobCardID;

    this.jobcardService.getJobCardLineItemsV1(this.serviceid, partnerID).subscribe((res) => {
      res.lineItem.forEach((element) => {
        //this.approvedList.push(element.approved === 1);
        this.approvedList.push(true);
        if (element.approved !== 1) this.allApproved = true;
      });
      this.lineItems = res.lineItem;
      this.showLabourHeading = res.lineItem.findIndex((x) => x.isNonInventory == true) > -1;
      this.showProductsHeading = res.lineItem.findIndex((x) => x.isNonInventory == false) > -1;
      this.currencySymbol = res.currencySymbol;
      this.sentApproval = res.sentApproval;
      this.vatInclusive = res.vatInclusive ? true : false;
      this.labourAmount = this.getSectionAmount(res.lineItem.filter((x) => x.isNonInventory));
      this.partsAmount = this.getSectionAmount(res.lineItem.filter((x) => !x.isNonInventory));
      if (res.invoiceTotal) {
        this.excluding = res.invoiceTotal.subtotal;
        this.discount = res.invoiceTotal.totalDiscount;
        this.tax = res.invoiceTotal.totalTax;
        this.total = res.invoiceTotal.totalPrice;
      }
      this.jobCard = res;
      this.technicianName = res.technicianName;
      this.technicianPhoto = res.technicianPhoto;
      this.getPaymentOptions(this.jobCard.partnerID);
      //this.getFullJobCard();
    });
  }

  // Same figures as the job card quote's sections: each line's price × quantity, less its discount
  getSectionAmount(lineItems: any[]) {
    return lineItems.reduce((sum: number, x: any) => {
      const price = this.vatInclusive ? x.unitPrice_IncludingTax : x.unitPrice;
      return sum + +(price * x.quantity).toFixed(2) - (+x.discount?.toFixed(2) || 0);
    }, 0);
  }

  getPaymentOptions(partnerID) {
    this.paymentService
      .checkPartnersStripePaymentOptions(partnerID)
      .subscribe((res) => {
        if (res && res.klarna_payments === 'active') {
          this.canDoKlarnaPayment = true;
        }
      });
  }

  getFullJobCard() {
    this.jobcardService.getFullJobCard(this.serviceid).subscribe((jobCard) => {
      this.jobCard = jobCard;
      this.technicianName = this.jobCard.technicianName;
      this.technicianPhoto = this.jobCard.technicianPhoto;
      this.getPaymentOptions(jobCard.partner.partnerID);

      if (
        this.jobCard.invoice.lineItems.findIndex(
          (x) => x.isNonInventory == true,
        ) > -1
      )
        this.showLabourHeading = true;

      if (
        this.jobCard.invoice.lineItems.findIndex(
          (x) => x.isNonInventory == false,
        ) > -1
      )
        this.showProductsHeading = true;

      this.lineItems.forEach((x) => {
        x.isNonInventory = this.jobCard.invoice.lineItems.find(
          (y) => y.id == x.id,
        ).isNonInventory;
      });

      console.log(this.lineItems);
    });
  }

  checkSendApproval() {
    let list = [];
    for (let i = 0; i < this.approvedList.length; i++) {
      if (this.approvedList[i]) {
        list.push(this.lineItems[i].id);
      }
    }
    if (this.allApproved) {
      this.sendApproval(list);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure?',
        html:
          'Are you sure you want to only send partial approval. The items not <br> ' +
          'approved will be taken away',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send partial',
      }).then((result) => {
        if (result.value) {
          this.sendApproval(list);
        }
      });
    }
  }

  sendApproval(list) {
    this.sent = true;
    this.jobcardService
      .postApproveLineItems({
        ApprovedItems: list,
        InvoiceID: this.lineItems[0].invoiceID,
        ApprovedStatus: this.allApproved ? 2 : 1,
      })
      .subscribe((res) => {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'The line items you have selected have been sent for approval',
          timer: 2000,
        });
      });
  }

  approvedItem = () => {
    this.allApproved = !this.approvedList.filter((x) => !x).length;
  };
}
